// stages.ts — Endpoints des étapes (stages) projet.
import { req } from './_internals.js';

export const stagesApi = {
  getStages: () => req('GET', '/stages'),
  createStage: (d: unknown) => req('POST', '/stages', d),
  updateStage: (id: number | string, d: unknown) => req('PUT', '/stages/' + id, d),
  deleteStage: (id: number | string) => req('DELETE', '/stages/' + id),
  reorderStages: (order: unknown) => req('PUT', '/stages', order),
};
